export const validateOib = (value) => {
  const oibDuljina = value.length;
  if (oibDuljina !== 11) return false;

  if ((oibDuljina === 11) && !isNaN(value)) {
    let a = 10;
    for (let i = 0; i < 10; i++) {
      a = a + parseInt(value.substr(i, 1), 10);
      a = a % 10;
      if (a === 0) a = 10;
      a *= 2;
      a = a % 11;
    }
    let kontrolni = 11 - a;
    if (kontrolni === 10) kontrolni = 0;
    if (kontrolni !== parseInt(value.substr(10, 1))) return false;
  }
  return true;
};

export const oibFieldHandleError = (flag, value) => {
  if (flag) {
    return !validateOib(value);
  } else if (value.length === 11) {
    return !validateOib(value);
  }
};

export const oibFieldHandlePasteAction = (e) => {
  let clipboardData, pastedData;
  clipboardData = e.clipboardData || window.clipboardData;
  pastedData = clipboardData.getData('Text');
  for (let i = 0; i < pastedData.length; i++) {
    if (["e", "E", "+", "-", "."].includes(pastedData.charAt(i))) {
      e.stopPropagation();
      e.preventDefault();
    }
  }
};

export const oibFieldHandleKeyboardKeyAction = (e) => {
  if (["e", "E", "+", "-", "."].includes(e.key)) {
    e.preventDefault();
  }
};

export const mailValidation = (value) => {
  if (value) {
    return !/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value);
  }
  return true;
};

export const mailMask = (value) => {
  const [name, domain] = value.split("@");
  const [domainName, domainExtension] = domain.split(".");
  const {length: nameLength} = name;
  const {length: domainNameLength} = domainName;
  let nameMask = "";
  let domainNameMask = "";

  for (let x = 1; x < nameLength - 1; x++) {
    nameMask += "*";
  }
  for (let x = 1; x < domainNameLength - 1; x++) {
    domainNameMask += "*";
  }

  const maskedName = name[0] + nameMask + name[nameLength - 1];
  const maskedDomain = domainName[0] + domainNameMask + domainName[domainNameLength - 1];
  return maskedName + "@" + maskedDomain + "." + domainExtension;

};

export const imagesValidation = (state, fieldRefs) => {
  /*if (state.images.length>=1) return true;
  else return false;*/
  let flag = true;
  state.images.every((value, index) => {
    if (!value) {
      fieldRefs.current[index].focus();
      flag = false;
      return false;
    }
    return true;
  });
  return flag;
};